// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ax-3";
export var contentContainer = "_ax-0";
export var editorContainer = "_ax-1";
export var quillInputForm = "_ax-2";
export var zoneDivider = "_ax-4";